import { render } from "./physicalDetail.vue?vue&type=template&id=267d0321&scoped=true"
import script from "./physicalDetail.vue?vue&type=script&lang=js"
export * from "./physicalDetail.vue?vue&type=script&lang=js"

import "./physicalDetail.vue?vue&type=style&index=0&id=267d0321&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267d0321"]])

export default __exports__